import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { EnumToUiOption } from '../../../../core/models/enum-to-ui.model';
import { IProductListFilter } from '../models/product.model';

export enum ProductCategoryEnum {
    EnginePoweredForklifts = 1,
    ElectricPoweredForklifts,
    ReachTrucks,
    PoweredStackers,
    PoweredPalletTrucks,
    OrderPickers,
    VeryNarrowAisleTrucks,
    TowingTractors,
    ElectricTuggers,
    Others,
}

export enum ProductIndustryEnum {
    Automotive = 1,
    AviationAndPorts,
    CleaningProfessional,
    Construction,
    Electronics,
    FoodAndBeverage,
    Healthcare,
    Hospitality,
    Manufacturing,
    Municipalities,
    OilAndGas,
    PaperAndPublishing,
    Retail,
    TimberAndWoodBased,
    WarehouseAndLogistics,
}

export enum WorkingEnvironmentEnum {
    Indoor = 1,
    Outdoor = 2,
    Both = 3,
}

export enum ProductTypeEnum {
    Seated = 1,
    Pedestrian,
    StandOn,
    Others,
}

export enum PowerSourceEnum {
    Battery = 1,
    Diesel,
    LPG,
    Petrol,
    Electric,
    Others,
}

export enum FeeTypeEnum {
    TransportationTwoWay = 1,
    Installation,
    SecurityDeposit,
    LongDistance,
}

export enum AisleWidthEnum {
    Standard = 1,
    Narrow = 2,
    VeryNarrow = 3,
}

export enum MastTypeEnum {
    FSV = 1,
    V,
    FV,
    DuplexHilo,
    DuplexTele,
    TriplexHilo,
}

export const PRODUCT_CATEGORIES_OPTIONS = new Map<ProductCategoryEnum, EnumToUiOption>([
    [
        ProductCategoryEnum.EnginePoweredForklifts,
        {
            label: _('Engine Powered Forklifts'),
            cssClass: '',
            order: 1,
            image: '/assets/images/home/product-category/engine-powered-forklifts.png',
        },
    ],
    [
        ProductCategoryEnum.ElectricPoweredForklifts,
        {
            label: _('Electric Powered Forklifts'),
            cssClass: '',
            order: 2,
            image: '/assets/images/home/product-category/electric-powered-forklifts.png',
        },
    ],
    [
        ProductCategoryEnum.ReachTrucks,
        {
            label: _('Reach Trucks'),
            cssClass: '',
            order: 3,
            image: '/assets/images/home/product-category/electric-reach-trucks.png',
        },
    ],
    [
        ProductCategoryEnum.PoweredStackers,
        {
            label: _('Powered Stackers'),
            cssClass: '',
            order: 4,
            image: '/assets/images/home/product-category/powered-stackers.png',
        },
    ],
    [
        ProductCategoryEnum.PoweredPalletTrucks,
        {
            label: _('Powered Pallet Trucks'),
            cssClass: '',
            order: 5,
            image: '/assets/images/home/product-category/powered-pallet-trucks.png',
        },
    ],
    [
        ProductCategoryEnum.OrderPickers,
        {
            label: _('Order Pickers'),
            cssClass: '',
            order: 6,
            image: '/assets/images/home/product-category/order-pickers.png',
        },
    ],
    [
        ProductCategoryEnum.VeryNarrowAisleTrucks,
        {
            label: _('Very Narrow Aisle Trucks'),
            cssClass: '',
            order: 7,
            image: '/assets/images/home/product-category/very-narrow-aisle-trucks.png',
        },
    ],
    [
        ProductCategoryEnum.TowingTractors,
        {
            label: _('Towing tractors'),
            cssClass: '',
            order: 8,
            image: '/assets/images/home/product-category/towing-tractors.png',
        },
    ],
    [
        ProductCategoryEnum.ElectricTuggers,
        {
            label: _('Electric Tuggers'),
            cssClass: '',
            order: 9,
            image: '/assets/images/home/product-category/electric-tuggers.png',
        },
    ],
    [
        ProductCategoryEnum.Others,
        {
            label: _('Others'),
            cssClass: '',
            order: 10,
            image: '/assets/images/home/product-category/other.png',
        },
    ],
]);

export const PRODUCT_INDUSTRY_OPTIONS = new Map<ProductIndustryEnum, EnumToUiOption>([
    [ProductIndustryEnum.Automotive, { label: _('Automotive'), cssClass: '', order: 1 }],
    [ProductIndustryEnum.AviationAndPorts, { label: _('Aviation & Ports'), cssClass: '', order: 2 }],
    [ProductIndustryEnum.CleaningProfessional, { label: _('Cleaning Professional'), cssClass: '', order: 3 }],
    [ProductIndustryEnum.Construction, { label: _('Construction'), cssClass: '', order: 4 }],
    [ProductIndustryEnum.Electronics, { label: _('Electronics'), cssClass: '', order: 5 }],
    [ProductIndustryEnum.FoodAndBeverage, { label: _('Food & Beverage'), cssClass: '', order: 6 }],
    [ProductIndustryEnum.Healthcare, { label: _('Healthcare'), cssClass: '', order: 7 }],
    [ProductIndustryEnum.Hospitality, { label: _('Hospitality'), cssClass: '', order: 8 }],
    [ProductIndustryEnum.Manufacturing, { label: _('Manufacturing'), cssClass: '', order: 9 }],
    [ProductIndustryEnum.Municipalities, { label: _('Municipalities'), cssClass: '', order: 10 }],
    [ProductIndustryEnum.OilAndGas, { label: _('Oil & Gas'), cssClass: '', order: 11 }],
    [ProductIndustryEnum.PaperAndPublishing, { label: _('Paper & Publishing'), cssClass: '', order: 12 }],
    [ProductIndustryEnum.Retail, { label: _('Retail'), cssClass: '', order: 13 }],
    [ProductIndustryEnum.TimberAndWoodBased, { label: _('Timber & Wood Based'), cssClass: '', order: 14 }],
    [ProductIndustryEnum.WarehouseAndLogistics, { label: _('Warehouse & Logistics'), cssClass: '', order: 15 }],
]);

export const WORKING_ENVIRONMENTS_OPTIONS = new Map<WorkingEnvironmentEnum, EnumToUiOption>([
    [WorkingEnvironmentEnum.Indoor, { label: _('Indoor'), cssClass: '' }],
    [WorkingEnvironmentEnum.Outdoor, { label: _('Outdoor'), cssClass: '' }],
    [WorkingEnvironmentEnum.Both, { label: _('Both'), cssClass: '' }],
]);

export const PRODUCT_TYPES_OPTIONS = new Map<ProductTypeEnum, EnumToUiOption>([
    [ProductTypeEnum.Seated, { label: _('Powered'), cssClass: '' }],
    [ProductTypeEnum.Pedestrian, { label: _('Unpowered'), cssClass: '' }],
    [ProductTypeEnum.StandOn, { label: _('Stand On'), cssClass: '' }],
    [ProductTypeEnum.Others, { label: _('Others'), cssClass: '' }],
]);

export const POWER_SOURCES_OPTIONS = new Map<PowerSourceEnum, EnumToUiOption>([
    [PowerSourceEnum.Battery, { label: _('Battery'), cssClass: '' }],
    [PowerSourceEnum.Diesel, { label: _('Diesel'), cssClass: '' }],
    [PowerSourceEnum.LPG, { label: _('LPG'), cssClass: '' }],
    [PowerSourceEnum.Petrol, { label: _('Petrol'), cssClass: '' }],
    [PowerSourceEnum.Electric, { label: _('Electric'), cssClass: '' }],
    [PowerSourceEnum.Others, { label: _('Others'), cssClass: '' }],
]);

export const AISLE_WIDTH_OPTIONS = new Map<AisleWidthEnum, EnumToUiOption>([
    [AisleWidthEnum.Standard, { label: _('Standard (3+m)'), description: _('Plenty of space to turn.'), cssClass: '' }],
    [AisleWidthEnum.Narrow, { label: _('Narrow (2-3m)'), description: _('Limited space.'), cssClass: '' }],
    [
        AisleWidthEnum.VeryNarrow,
        { label: _('Very Narrow (1.2-2m)'), description: _('Very limited space.'), cssClass: '' },
    ],
]);

export const MAST_TYPE_OPTIONS = new Map<MastTypeEnum, EnumToUiOption>([
    [MastTypeEnum.FSV, { label: _('FSV (3 Stage, Wide Visible Full-Free Lift Mast)'), cssClass: '', order: 1 }],
    [MastTypeEnum.V, { label: _('V (2 Stage, Wide Visible Mast)'), cssClass: '', order: 2 }],
    [MastTypeEnum.FV, { label: _('FV (2 Stage, Wide Visible Full-Free Lift Mast)'), cssClass: '', order: 3 }],
    [MastTypeEnum.DuplexHilo, { label: _('Duplex Hilo'), cssClass: '', order: 4 }],
    [MastTypeEnum.DuplexTele, { label: _('Duplex Tele'), cssClass: '', order: 5 }],
    [MastTypeEnum.TriplexHilo, { label: _('Triplex Hilo'), cssClass: '', order: 6 }],
]);

export function getProductCategoryOption(feeType: ProductCategoryEnum): EnumToUiOption {
    const foundOption = PRODUCT_CATEGORIES_OPTIONS.get(feeType);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getWorkingEnvironmentOption(environment: WorkingEnvironmentEnum): EnumToUiOption {
    const foundOption = WORKING_ENVIRONMENTS_OPTIONS.get(environment);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getProductTypeOption(type: ProductTypeEnum): EnumToUiOption {
    const foundOption = PRODUCT_TYPES_OPTIONS.get(type);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getPowerSourceOption(source: PowerSourceEnum): EnumToUiOption {
    const foundOption = POWER_SOURCES_OPTIONS.get(source);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getAisleWidthOption(width: AisleWidthEnum): EnumToUiOption {
    const foundOption = AISLE_WIDTH_OPTIONS.get(width);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getMastTypeOption(mastType: MastTypeEnum): EnumToUiOption {
    const foundOption = MAST_TYPE_OPTIONS.get(mastType);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export const CREATE_NEW_PRODUCT_FILTER = (): IProductListFilter => ({
    industries: [],
    categories: [],
    workingEnvironments: [],
    aisleWidthCategory: [],
});
